import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const LOGIN_URL =
  "https://payhip.com/ViraAI/users/login?redirect=https%3A%2F%2Fpayhip.com%2FViraAI%2Fb-account";
const CHECKOUT_URL = "https://payhip.com/order?link=8mes1&pricing_plan=YLBN5OxvzK";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <motion.nav
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-xl border-b border-[#C9A84C]/10 transition-shadow duration-300"
      style={{ height: "60px", boxShadow: scrolled ? "0 8px 30px rgba(0,0,0,0.45)" : "none" }}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center justify-between">
        {/* Text Logo */}
        <a href="/" data-testid="navbar-logo" className="flex items-center">
          <span
            className="text-2xl font-black tracking-tight leading-none"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="text-[#F0EDE8]">Vira</span>
            <span className="text-[#C9A84C]">Ai</span>
          </span>
        </a>
        <div className="flex items-center gap-3">
          <a
            href={LOGIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="login-button"
            className="text-[#9A9A9A] hover:text-[#F0EDE8] text-sm font-medium transition-colors duration-200 px-3 py-1.5 border border-white/10 rounded-lg hover:border-white/20"
          >
            Einloggen
          </a>
          <a
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-cta-button"
            className="hidden sm:inline-block bg-[#C9A84C] text-[#0A0A0A] font-bold text-sm px-5 py-2 rounded-lg hover:bg-[#E0C375] transition-colors duration-200"
          >
            Jetzt für 299€ →
          </a>
        </div>
      </div>
    </motion.nav>
  );
}
